import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({ providedIn: 'root' })
export class ApiDataTravelMemberPhysicalConditionService {
  constructor(private _api: ApiService) {}

  get(id: number | string) {
    return this._api.get('data-travel-member-physical-condition/get/id/' + id);
  }

  list(data: any = {}) {
    return this._api.post('data-travel-member-physical-condition/list', data);
  }

  create(data: any) {
    return this._api.post('data-travel-member-physical-condition/create', data);
  }

  update(data: any) {
    return this._api.post('data-travel-member-physical-condition/update', data);
  }

  remove(id: number) {
    return this._api.post(
      'data-travel-member-physical-condition/remove/id/' + id
    );
  }
}
